import styled from 'styled-components'

const DatePublished = styled.div`
  flex: 1;
  box-sizing: border-box;
  padding-left: 15px;
  color: ${({ theme }) => theme.colors.grey.grey_70};
  text-align: right;
  font-size: 14px;
  font-weight: 500;
`

export default DatePublished
